import React from 'react';
import { Cushion, Grid, MaxWidth } from '@pitchero/react-ui';
import ArticleLoadingPlaceHolder from '../article/loading-placeholder';
import EventAttendanceLoadingState from './event-attendance-loading-state';

const ClubEventLoadingState = () => (
  <Cushion
    all="large"
    responsive={[{ maxWidth: 450, props: { horizontal: 'small' } }]}
    component="div"
  >
    <MaxWidth component="div" maxWidth={1366} center>
      <Grid preset="clubEvent">
        <div style={{ gridArea: 'article' }}>
          <ArticleLoadingPlaceHolder />
        </div>
        <div style={{ gridArea: 'attendance' }}>
          <EventAttendanceLoadingState />
        </div>
      </Grid>
    </MaxWidth>
  </Cushion>
);

export default ClubEventLoadingState;
